/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 用户实名制认证
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  identifyRequest: member.IdentifyRequest,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/setting/identify`,
    data: identifyRequest,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
